<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'feedback-rating-report.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="navigate()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'feedback-rating-report.dates' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-range-select>
            </div>
          </div>

          <div *ngIf="feedbackStoreRatingList.length && !isLoading.store">
            <br><br>
            <span style="font-weight: bold">{{ 'feedbackStoreRating' | transloco }}</span>
            <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
              <table class="m-datatable__table">
                <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell">{{ 'feedback-rating-report.shop' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'feedback-rating-report.table.head.city' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'feedback-rating-report.table.head.startDate' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'feedback-rating-report.table.head.endDate' | transloco }}</th>
                  <th class="m-datatable__cell text-right">{{ 'feedback-rating-report.table.head.rating' | transloco }}</th>
                </tr>
                </thead>
                <tbody class="m-datatable__body">
                <ng-container *ngFor="let even = even;let i = index; let storeRating of feedbackStoreRatingList">
                  <tr class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even}">
                    <td class="m-datatable__cell">{{ storeRating.storeTitle | uiLabel }}</td>
                    <td class="m-datatable__cell">{{ storeRating.cityTitle | uiLabel }}</td>
                    <td class="m-datatable__cell">{{ storeRating.startWorkDate | date: 'dd.MM.yyyy' }}</td>
                    <td class="m-datatable__cell">{{ storeRating.endWorkDate | date: 'dd.MM.yyyy' }}</td>
                    <td class="m-datatable__cell text-right">{{ storeRating.rating }}</td>
                  </tr>
                </ng-container>
                </tbody>
              </table>
            </div>
            <br/>
            <br/>
          </div>

          <div *ngIf="feedbackTypeRatingList.length && !isLoading.type">
            <span style="font-weight: bold">{{ 'feedbackTypeRating' | transloco }}</span>
            <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
              <table class="m-datatable__table">
                <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell">{{ 'feedback-rating-report.shop' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'feedback-rating-report.type' | transloco }}</th>
                  <th class="m-datatable__cell text-right">{{ 'feedback-rating-report.rating' | transloco }}</th>
                </tr>
                </thead>
                <tbody class="m-datatable__body">
                <ng-container *ngFor="let even = even;let i = index; let typeRating of feedbackTypeRatingList">
                  <tr class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even}">
                    <td class="m-datatable__cell">{{ typeRating.storeTitle | uiLabel }}</td>
                    <td class="m-datatable__cell">{{ 'feedback.type.' + typeRating.type | transloco }}</td>
                    <td class="m-datatable__cell text-right">{{ typeRating.rating }}</td>
                  </tr>
                </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <br/>
          <br/>
          <hx-loader [length]="feedbackStoreRatingList.length || feedbackTypeRatingList.length" [isLoading]="isLoading.store || isLoading.type"></hx-loader>
        </div>
      </div>
    </div>
  </div>
</div>
